/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import axios from 'axios';
import { getCurrentSubdomain } from './Subdomain';
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            const URL_SUBDOMAIN = getCurrentSubdomain();
            if (type === ContentType.FormData &&
                body &&
                body !== null &&
                typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                const formData = this.createFormData(body);
            }
            return this.instance.request({
                ...requestParams,
                headers: {
                    ...(type && type !== ContentType.FormData
                        ? { 'Content-Type': type }
                        : {}),
                    ...(requestParams.headers || {}),
                    ...({ 'X-Product': URL_SUBDOMAIN }),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || 'http://product-editor.phoenix.local',
            withCredentials: true,
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.instance.defaults.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
/**
 * @title Phoenix ProductEditor API
 * @version 1.0.0@dev
 * @baseUrl http://product-editor.phoenix.local
 *
 * New structure for OPEN API
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.api = {
            /**
             * No description
             *
             * @tags Dictionaries
             * @name PhoenixProductEditorHttpControllersApiDictionariesControllerProductTypes
             * @summary Getting list of available product types
             * @request GET:/api/dictionaries/product-types
             * @secure
             * @response `200` `(ProductType)[]` List of product types
             * @response `401` `void` No authorized
             */
            phoenixProductEditorHttpControllersApiDictionariesControllerProductTypes: (params = {}) => this.request({
                path: `/api/dictionaries/product-types`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dictionaries
             * @name PhoenixProductEditorHttpControllersApiDictionariesControllerUnitTypes
             * @summary Getting list of available unit types
             * @request GET:/api/dictionaries/unit-types
             * @secure
             * @response `200` `(ProductUnitType)[]` List of unit types
             * @response `401` `void` No authorized
             */
            phoenixProductEditorHttpControllersApiDictionariesControllerUnitTypes: (params = {}) => this.request({
                path: `/api/dictionaries/unit-types`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dictionaries
             * @name PhoenixProductEditorHttpControllersApiDictionariesControllerCountries
             * @summary Getting list of countries
             * @request GET:/api/dictionaries/countries
             * @secure
             * @response `200` `(Country)[]` List of countries
             * @response `401` `void` No authorized
             */
            phoenixProductEditorHttpControllersApiDictionariesControllerCountries: (params = {}) => this.request({
                path: `/api/dictionaries/countries`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dictionaries
             * @name PhoenixProductEditorHttpControllersApiDictionariesControllerCities
             * @summary Getting list of cities
             * @request GET:/api/dictionaries/cities
             * @secure
             * @response `200` `(City)[]` List of cities
             * @response `401` `void` No authorized
             */
            phoenixProductEditorHttpControllersApiDictionariesControllerCities: (query, params = {}) => this.request({
                path: `/api/dictionaries/cities`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dictionaries
             * @name PhoenixProductEditorHttpControllersApiDictionariesControllerCurrencies
             * @summary Getting list of currencies
             * @request GET:/api/dictionaries/currencies
             * @secure
             * @response `200` `(Currency)[]` List of currencies
             * @response `401` `void` No authorized
             */
            phoenixProductEditorHttpControllersApiDictionariesControllerCurrencies: (params = {}) => this.request({
                path: `/api/dictionaries/currencies`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Dictionaries
             * @name PhoenixProductEditorHttpControllersApiDictionariesControllerSkuAutocomplete
             * @summary SKU Autocomplete
             * @request GET:/api/sku/autocomplete
             * @secure
             * @response `200` `(StockSku)[]` List of found SKU
             * @response `401` `void` No authorized
             */
            phoenixProductEditorHttpControllersApiDictionariesControllerSkuAutocomplete: (query, params = {}) => this.request({
                path: `/api/sku/autocomplete`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerSwitchToAdvanced
             * @summary Switching variant, to advanced pricing
             * @request GET:/api/pricing/{variantId}/switch-to-advanced
             * @secure
             * @response `200` `void` Operation success
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerSwitchToAdvanced: (variantId, params = {}) => this.request({
                path: `/api/pricing/${variantId}/switch-to-advanced`,
                method: 'GET',
                secure: true,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerGetPricingDetails
             * @summary Get pricing details
             * @request GET:/api/pricing/details/{pricingId}
             * @secure
             * @response `200` `object` Pricing details
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerGetPricingDetails: ({ pricingId, ...query }, params = {}) => this.request({
                path: `/api/pricing/details/${pricingId}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerGetPricingCalendars
             * @summary Get pricing calendars for variant
             * @request GET:/api/pricing/{variantId}
             * @secure
             * @response `200` `(PricingCalendar)[]` Pricings
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerGetPricingCalendars: (variantId, params = {}) => this.request({
                path: `/api/pricing/${variantId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerCreatePricingCalendar
             * @summary Creating pricing calendar
             * @request POST:/api/pricing/{variantId}
             * @secure
             * @response `200` `PricingCalendar` Calendar created
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerCreatePricingCalendar: (variantId, data, params = {}) => this.request({
                path: `/api/pricing/${variantId}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerUpdatePricingCalendar
             * @summary Updating pricing calendar
             * @request PATCH:/api/pricing/{variantId}/calendar/{calendarId}
             * @secure
             * @response `200` `PricingCalendar` Calendar updated
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerUpdatePricingCalendar: (variantId, calendarId, data, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${calendarId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerSetCalendarDefault
             * @request GET:/api/pricing/{variantId}/calendar/{calendarId}/set-default
             * @secure
             * @response `200` `(PricingCalendar)[]` Pricings
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerSetCalendarDefault: (variantId, calendarId, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${calendarId}/set-default`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerCreateBlackout
             * @summary Creating blackout
             * @request POST:/api/pricing/{variantId}/calendar/{calendarId}/blackout
             * @secure
             * @response `200` `PricingBlackout` Blackout created
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerCreateBlackout: (variantId, calendarId, data, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${calendarId}/blackout`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerUpdateBlackout
             * @summary Updating blackout
             * @request PATCH:/api/pricing/{variantId}/calendar/{calendarId}/blackout/{blackoutId}
             * @secure
             * @response `200` `PricingBlackout` Blackout updated
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerUpdateBlackout: (variantId, calendarId, blackoutId, data, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${calendarId}/blackout/${blackoutId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerCreateException
             * @summary Create exception
             * @request POST:/api/pricing/{variantId}/calendar/{calendarId}/exception
             * @secure
             * @response `200` `PricingException` Exception created
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerCreateException: (variantId, calendarId, data, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${calendarId}/exception`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerUpdateException
             * @summary Update exception
             * @request PATCH:/api/pricing/{variantId}/calendar/{calendarId}/exception/{exceptionId}
             * @secure
             * @response `200` `PricingException` Exception updated
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerUpdateException: (variantId, calendarId, exceptionId, data, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${calendarId}/exception/${exceptionId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerDeletePricingCalendar
             * @request DELETE:/api/pricing/{variantId}/calendar/{pricingCalendarId}
             * @secure
             * @response `200` `(PricingCalendar)[]` Calendar deleted, fetching new
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerDeletePricingCalendar: (variantId, pricingCalendarId, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${pricingCalendarId}`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Pricing
             * @name PhoenixProductEditorHttpControllersApiPricingControllerDeleteBlackout
             * @request DELETE:/api/pricing/{variantId}/calendar/{pricingCalendarId}/blackout/{blackoutId}
             * @secure
             * @response `200` `(PricingBlackout)[]` Blackout deleted, fetching new blackouts
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiPricingControllerDeleteBlackout: (variantId, pricingCalendarId, blackoutId, params = {}) => this.request({
                path: `/api/pricing/${variantId}/calendar/${pricingCalendarId}/blackout/${blackoutId}`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description Fetching available catalogs for user
             *
             * @tags Catalogs
             * @name PhoenixProductEditorHttpControllersApiProductCatalogControllerIndex
             * @request GET:/api/catalogs
             * @secure
             * @response `200` `PaginatedCatalog` Paginated list of catalogs
             * @response `401` `void` No auth
             */
            phoenixProductEditorHttpControllersApiProductCatalogControllerIndex: (query, params = {}) => this.request({
                path: `/api/catalogs`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description Fetching categories for catalog
             *
             * @tags Categories
             * @name PhoenixProductEditorHttpControllersApiProductCategoryControllerIndex
             * @request GET:/api/category-tree/{catalogId}
             * @secure
             * @response `200` `(ProductCategoryNode)[]` List of categories
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductCategoryControllerIndex: (catalogId, params = {}) => this.request({
                path: `/api/category-tree/${catalogId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Inventory
             * @name PhoenixProductEditorHttpControllersApiProductInventoryControllerGetLimitsForUnit
             * @summary Getting limits for product unit
             * @request GET:/api/inventory-status/{productUnitId}
             * @secure
             * @response `200` `{ total?: number, daily?: number }` List of categories
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductInventoryControllerGetLimitsForUnit: (productUnitId, params = {}) => this.request({
                path: `/api/inventory-status/${productUnitId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name ProductListGet
             * @summary fetching paginated list of products
             * @request GET:/api/products
             * @secure
             * @response `200` `PaginatedProducts` List of products
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            productListGet: (query, params = {}) => this.request({
                path: `/api/products`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerStore
             * @summary Creating product
             * @request POST:/api/product
             * @secure
             * @response `200` `object` Product created
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerStore: (data, params = {}) => this.request({
                path: `/api/product`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name ProductGet
             * @summary Fetching info about single product
             * @request GET:/api/product/{productId}
             * @secure
             * @response `200` `ProductShow` Info about product
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            productGet: (productId, params = {}) => this.request({
                path: `/api/product/${productId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerDelete
             * @summary Delete product
             * @request DELETE:/api/product/{productId}
             * @secure
             * @response `200` `({ message?: string, success?: boolean })` Unit removed
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerDelete: (productId, params = {}) => this.request({
                path: `/api/product/${productId}`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerUpdate
             * @summary Updating product
             * @request PATCH:/api/product/{productId}
             * @secure
             * @response `200` `object` Product created
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerUpdate: (productId, data, params = {}) => this.request({
                path: `/api/product/${productId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerOrderImages
             * @summary Reorder product images
             * @request POST:/api/product/{productId}/order-images
             * @secure
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerOrderImages: (productId, data, params = {}) => this.request({
                path: `/api/product/${productId}/order-images`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerStoreVariant
             * @summary Create variant
             * @request POST:/api/product/{productId}/variant
             * @secure
             * @response `200` `{ message?: string, variant?: ProductVariant }` Variant created
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerStoreVariant: (productId, data, params = {}) => this.request({
                path: `/api/product/${productId}/variant`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerDeleteVariant
             * @summary Delete variant
             * @request DELETE:/api/product/{productId}/variant/{variantId}
             * @secure
             * @response `200` `({ message?: string, success?: boolean })` Unit removed
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerDeleteVariant: (productId, variantId, params = {}) => this.request({
                path: `/api/product/${productId}/variant/${variantId}`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerUpdateVariant
             * @summary Update variant
             * @request PATCH:/api/product/{productId}/variant/{variantId}
             * @secure
             * @response `200` `{ message?: string, variant?: ProductVariant }` Variant updated
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerUpdateVariant: (productId, variantId, data, params = {}) => this.request({
                path: `/api/product/${productId}/variant/${variantId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerStoreUnit
             * @summary Create unit
             * @request POST:/api/product/{productId}/variant/{variantId}/unit
             * @secure
             * @response `200` `{ message?: string, variant?: ProductUnit }` Variant updated
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerStoreUnit: (productId, variantId, data, params = {}) => this.request({
                path: `/api/product/${productId}/variant/${variantId}/unit`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerDeleteUnit
             * @summary Delete unit
             * @request DELETE:/api/product/{productId}/variant/{variantId}/unit/{unitId}
             * @secure
             * @response `200` `({ message?: string, success?: boolean })` Unit removed
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerDeleteUnit: (productId, variantId, unitId, params = {}) => this.request({
                path: `/api/product/${productId}/variant/${variantId}/unit/${unitId}`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerUpdateUnit
             * @summary Update unit
             * @request PATCH:/api/product/{productId}/variant/{variantId}/unit/{unitId}
             * @secure
             * @response `200` `{ message?: string, variant?: ProductUnit }` unit updated
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerUpdateUnit: (productId, variantId, unitId, data, params = {}) => this.request({
                path: `/api/product/${productId}/variant/${variantId}/unit/${unitId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerSyncCategories
             * @summary sync selected product categories
             * @request POST:/api/product/{productId}/sync-categories
             * @secure
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerSyncCategories: (productId, data, params = {}) => this.request({
                path: `/api/product/${productId}/sync-categories`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerSyncAttributes
             * @summary sync selected product categories attributes
             * @request POST:/api/product/{productId}/sync-attributes
             * @secure
             * @response `400` `void` Bad request
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerSyncAttributes: (productId, data, params = {}) => this.request({
                path: `/api/product/${productId}/sync-attributes`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerToggleVariantActivity
             * @summary Toggle variant activity
             * @request GET:/api/product/{productId}/variant/{variantId}/toggle-activity
             * @secure
             * @response `200` `({ active?: boolean, message?: string, success?: boolean })` Variant toggled or toggle failed
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerToggleVariantActivity: (productId, variantId, params = {}) => this.request({
                path: `/api/product/${productId}/variant/${variantId}/toggle-activity`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Products
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerToggleProductActivity
             * @summary Toggle product activity
             * @request GET:/api/product/{productId}/toggle-activity
             * @secure
             * @response `200` `({ active?: boolean, message?: string, success?: boolean })` Product active toggled or toggle failed
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerToggleProductActivity: (productId, params = {}) => this.request({
                path: `/api/product/${productId}/toggle-activity`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description Generating unique product code
             *
             * @tags Product
             * @name PhoenixProductEditorHttpControllersApiProductSaveControllerGetUniqueCode
             * @request GET:/api/product/unique-code/{productTypeId}
             * @secure
             * @response `200` `{ code?: string }` Unique product code
             * @response `401` `void` No auth
             * @response `404` `void` Not found
             */
            phoenixProductEditorHttpControllersApiProductSaveControllerGetUniqueCode: (productTypeId, params = {}) => this.request({
                path: `/api/product/unique-code/${productTypeId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags ProductsAttributes
             * @name ProductCategoriesAttributesGet
             * @summary Fetching info about product categories attributes
             * @request GET:/api/product/{productId}/categories-attributes
             * @secure
             * @response `200` `ProductCategoryAttributeWithValues` Info about product categories attributes
             * @response `401` `void` No auth
             * @response `403` `void` No permissions
             */
            productCategoriesAttributesGet: (productId, params = {}) => this.request({
                path: `/api/product/${productId}/categories-attributes`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags User
             * @name PhoenixProductEditorHttpControllersApiUserControllerGetUserPermissions
             * @summary Getting user permissions according to products
             * @request GET:/api/user-permissions
             * @secure
             * @response `200` `(string)[]` Array with permissions
             * @response `401` `void` No auth
             */
            phoenixProductEditorHttpControllersApiUserControllerGetUserPermissions: (params = {}) => this.request({
                path: `/api/user-permissions`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
        };
    }
}
